let theme = {
  title: "主题设置 ",
  subTitle:"自定义皮肤、主题",
  themeSet: {
    title: '主题',
    skin: {
      title: '皮肤',
      default: '默认',
      border: '边框',
      dark: '暗黑',
    },
    mode: {
      title: '模式',
      highlight: '高亮',
      dark: '暗黑',

    }
  }
,
    layoutSet:{
      title:'布局 ',
      bodyWidth:{
        title:'主体宽度',
        beFilledWith:'充满',
        fine:'精致'
      },
      appType:{
        title:'应用程序栏类型',
        fixed:'固定',
        show:'显示',
        hide:'隐藏'

      },
      nav:{
        title:'导航栏',
        merge:'合并导航栏',
        hide:'隐藏导航栏',
      }
    }



}

export default theme
